export default "/public/icons-sprite-1cca55dbbf6e277f2ec6a9596e771220.svg";